import React, { useRef, useState } from "react";
import { ValidatorForm } from "react-form-validator-core";
import TextValidator from "../../partial/TextValidator";
import Loader from "../../partial/Loader";
import { AddReferralData } from "../../auth/auth";
import swal from "sweetalert";
import { Link, useNavigate } from "react-router-dom";


const ReferForm = ({ label, placeholder, refreetype }) => {
  const navigate = useNavigate();
  const formRef = useRef();
  const [loader, setLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [state, setState] = useState({
    customerid: localStorage.getItem("customerid"),
    refreetype: refreetype,
    refreeename: "",
    refree_mobile: "",
    CreatedDate: new Date(),
    merchantcode: "MER000325",
  });
  const { refreeename, refree_mobile } = state;

  const onChange = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = async () => {
    setLoader(true);
    try {
      let token = await JSON.parse(localStorage.getItem("token_gen"));
      let response = await AddReferralData(token.access_token,state);
      setLoader(false);
      if (response?.message === "Success") {
        setShowPopup(true);
        setState({ ...state, refreeename: "", refree_mobile: "" });
      } else {
        swal({
          position: "center",
          icon: "error",
          title: response?.message,
          showConfirmButton: false,
          timer: 5000,
        });
      }
    } catch (error) {
      setLoader(false);
      swal({
        position: "center",
        icon: "error",
        title: "An error occurred. Please try again.",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  };

  const handleClosePopup = (e) => {
    e.preventDefault();
    setShowPopup(false);
    navigate("/home");
  };

  const getButtonClass = () => {
    switch (refreetype) {
      case "Retailer":
        return "btn btn-block btn-green";
      case "Distributor":
        return "btn btn-block btn-yellow-gold";
      case "Brand":
        return "btn btn-block btn-purple";
      default:
        return "btn btn-block btn-primary";
    }
  };

  return (
    <div className="route-form">
      {loader && <Loader />}
      <ValidatorForm ref={formRef} onSubmit={onSubmit}>
        <div className="formbox">
          <span className="label">{label}</span>
          <TextValidator
            placeholder={placeholder}
            className="form-control"
            name="refreeename"
            maxLength="50"
            value={refreeename}
            type="text"
            onChange={onChange}
            validators={["required"]}
            errorMessages={["This field is required"]}
          />
        </div>
        <div className="formbox">
          <span className="label">Mobile Number</span>
          <TextValidator
            placeholder="Enter 10-digit mobile number"
            className="form-control"
            name="refree_mobile"
            maxLength="10"
            value={refree_mobile}
            type="text"
            onChange={onChange}
            validators={[
              "required",
              "matchRegexp:^(?!\\d*(\\d)\\1{7,}|0123456789|1234567890)\\d{10}$",
            ]}
            errorMessages={[
              "This field is required",
              "Please enter a valid number",
            ]}
          />
        </div>
        <div className="formbox">
          <button type="submit" className={getButtonClass()}>
            Submit Referral
          </button>
        </div>
      </ValidatorForm>

      {showPopup && (
        <div className="popup show" id="referral_successful">
          <div className="popup-box">
            <Link
              className="close-popup"
              id="close_referral_successful"
              onClick={handleClosePopup}
            >
              X
            </Link>
            <div className="popup-box-inner">
              <img src="/images/successful.png" className="success" alt="" />
              <h5 className="big">Referral Successful!</h5>
              <p className="small">
                Great job! As soon as your friend signs up, your rewards will roll
                in. Want more perks? <br />
                Keep referring!
              </p>
            </div>
          </div>
        </div>
        
      )}
    </div>
  );
};

export default ReferForm;